import { isEmpty } from 'lodash';
import { ShowroomService, TradeInsService, Vehicle } from '@sm360/widget-commons-vehicle';
import TRANSACTION from 'login/constants/transaction.js';
import forOwn from 'lodash/forOwn';

class TransactionStateService {
    constructor() {
        this.completedSteps = null;
    }

    fetchStepStatus() {
        const garagePromise = ShowroomService.loadQuotesV25()
            .then((quotes) => Promise.resolve(isEmpty(quotes) ? 0 : quotes.length))
            .catch(() => Promise.resolve(0));

        const tradeInPromise = TradeInsService.loadTradeInVehicle().catch(() => Promise.resolve(null));

        const financePromise = ShowroomService.loadCreditApplication()
            .then((creditApplication) => Promise.resolve(!!creditApplication))
            .catch(() => Promise.resolve(false));

        return Promise.all([garagePromise, tradeInPromise, financePromise]).then(
            ([garageCount, rawTradeIn, isFinanceCompleted]) => {
                const tradeIn = rawTradeIn ? new Vehicle.TradeInVehicleModel(rawTradeIn) : rawTradeIn;
                this.completedSteps = {
                    garageCount,
                    garage: garageCount > 0,
                    tradein: !!tradeIn,
                    tradeInAmount: tradeIn && tradeIn.amount ? tradeIn.amount : null,
                    tradeInTaxCredits: tradeIn && tradeIn.amount ? tradeIn.getTaxCredits() : null,
                    finance: isFinanceCompleted,
                };

                return Promise.resolve(this.completedSteps);
            }
        );
    }

    getStepStatus(forceRefresh) {
        if (forceRefresh || !this.completedSteps) {
            return this.fetchStepStatus();
        }

        return Promise.resolve(this.completedSteps);
    }

    getSavedTime() {
        return this.getStepStatus(true).then((completedSteps) => {
            let savedTime = 0;
            forOwn(TRANSACTION, (currentTransaction) => {
                if (completedSteps[currentTransaction.label]) {
                    savedTime += currentTransaction.timeSaved;
                }
            });
            return Promise.resolve(savedTime);
        });
    }
}

export default new TransactionStateService();
